import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from "../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";
import {ReportComponentModel} from "../../../api/entity/reportComponent.model";
import {ReportComponentDataService} from "./reportComponentData.service";
import {ReportComponentConverter} from "../../../api/entity/converter/reportComponent.converter";

@Injectable()
export class ReportComponentDataServiceAdapter extends AbstractDataServiceDtoAdapter<ReportComponentModel, ReportComponentConverter> {
    constructor(dataService: ReportComponentDataService, converter: ReportComponentConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ReportComponentModel {
        return new ReportComponentModel();
    }
}
